import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../../../../pages/Loading/Loading';

const Checklist = lazy(() => import('../../../../../../../pages/Checklist/Checklist'));

export const Route = createFileRoute('/$lang/_authenticated/checklist/$name/$id/$historyId')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <Checklist />
    </Suspense>
  ),
});
